import type { ReactNode, LabelHTMLAttributes } from "react";
import { cn } from "@/utils/cn";

type LabelProps = LabelHTMLAttributes<HTMLLabelElement> & {
  children: ReactNode;
};

export function Label({ className, children, ...rest }: LabelProps) {
  return (
    <label className={cn("label", className)} {...rest}>
      {children}
    </label>
  );
}

type SlashLabelProps = {
  className?: string;
  children: ReactNode;
};

export function SlashLabel({ className, children }: SlashLabelProps) {
  return <div className={cn("slash-label", className)}>{children}</div>;
}
